$(function(){
	$('body').addClass('loaded');
	
	$('.st-menu h2').click(function(){
		if($(this).next().hasClass('open')){
			$(this).next().removeClass('open');
		}else{
			$('.st-menu .nav.open').removeClass('open');
			$(this).next().addClass('open');
		}	
	});
	
	callbacks();
    ajaxContent();
});

$(window).load(function(){
	/* Fix iframe z-index*/
	$.cookieBar({
		element: 'body',
		zindex: '999999', 
		message: COOKIE_MSG,
		//message: 'By using this website you agree to our use of cookies. You can find out more by reading the <a href="'+PRIVACY_URL+'">Privacy Policy</a>',
		acceptText: '',
		/*policyText: 'Privacy Policy', policyURL: '#',*/
		domain: 'www.fnl-guide.com',
		referrer: 'www.fnl-guide.com'
	});
	
	setTimeout(function(){ 
		$('iframe').each(function(){
			// var url = $(this).attr("src");
			// var char = "?";
			//if(url.indexOf("?") != -1){
			//       var char = "&";
			//}
			
			//$(this).attr("src",url+char+"wmode=transparent"); 
			$(this).attr("wmode","transparent");
		});
		//console.log($('iframe embed'));
	}, 2000);
});

$(document).ready(function() {
	$(".popup_ajax").fancybox({
		type	: 'ajax',
		arrows	: false,
		helpers : {
        overlay : {
				css : {
					'background' : 'rgba(0, 0, 0, 0.8)'
				}
			}
		}
	});

	$(".fancybox-trigger-video").fancybox({
	'width'		: 680,
	'height'		: 495,
	afterShow: function() {
		this.content.find('video').get(0).play();
	},
	beforeClose: function() {
		this.content.find('video').get(0).pause();
		this.content.find('video').get(0).currentTime = 0;
	}
	});
	 
	$(document).on("click", '.more-results', function ($e) {
		var target = $(this).attr('rel');
		more(target);
		return false;
	});
	
	$(document).on("click", '.scroll-top', function ($e) {
		$(document).stop().animate({scrollTop: 0}, 'fast');
		return false;
	});
	
	$(document).on('scroll',function() {
		
		positionMenu();
		positionSkinBanner();

		if($(window).scrollTop() + $(window).height() >= getDocHeight()-500) {
			if($('.related-articles-read-more').length > 0 && $('.related-articles-read-more').hasClass('hidden')){
                $('.related-articles-read-more .grid').addClass('loaded');
                $('.related-articles-read-more .grid .grid-item').addClass('shown');
                $('.related-articles-read-more').removeClass('hidden').css('bottom',-$('.related-articles-read-more').height())
                $('.related-articles-read-more').animate({bottom:$('.footer-nav').height()},500,"easeOutQuart",function(){ });
                setTimeout(function(){
                    $('.hide-most-clicked').trigger('click');
                },5000);
            }	
		}

        var scroll_pos = $(document).scrollTop();
        var screen_height = $('body').height();

        if($('.autoload-threshold').length > 0){
			if($('.autoload-threshold')[0].getBoundingClientRect().bottom <= $(window).height()) {
				if( !$('.more-results[rel="news"]').hasClass('loading') ){
					//$('.more-results[rel="news"]').trigger('click');
				}
				if( !$('.more-results[rel="tweets"]').hasClass('loading') ){
					//$('.more-results[rel="tweets"]').trigger('click');
				}
				if( !$('.more-results[rel="events"]').hasClass('loading') ){
					//$('.more-results[rel="events"]').trigger('click');
				}
			}
        }

        if($(document).scrollTop() < 100 ){
            $('.scroll-top').fadeOut('fast');
            if($('.slidebar-banner-mobile').length>0 &&  $('.scroll-top').length>0 ){
            	$('.slidebar-banner-mobile').removeClass('scrolled');
            }
        }else{
            $('.scroll-top').fadeIn('fast');
            if($('.slidebar-banner-mobile').length>0 &&  $('.scroll-top').length>0 ){
            	$('.slidebar-banner-mobile').addClass('scrolled');
            }
        }
	});
	
	positionSkinBanner();

	setTimeout(function(){
		$('.emptybanner').each(function(){
            $(this).closest('.full-banner').hide();
            $(this).closest('.sidebar-banner').hide();
			$(this).closest('.grid-item').hide();
            $(this).closest('.prime').hide();
            $(this).closest('.generic-banner').hide();
        });
	},1000);

	
});

function positionSkinBanner(){
	if($('.page-skin-container').length> 0){
		if($('#content-area')[0].getBoundingClientRect().top <= 50) {
			$('.page-skin-container').addClass('fixed-top');
		}else if($('.page-skin-container').hasClass('fixed-top')){
			$('.page-skin-container').removeClass('fixed-top');	
		}
	}	
}
function positionMenu(){
	var topCuttoff = $('.top-prime').height();
	var mainCuttoff = $('.top-prime').height()+$('.header').height()-$('.main-nav').height();
	
	if($(document).scrollTop()>topCuttoff){
		$('.top-links').addClass('navbar-fixed-top');		
	}else if($('.top-links').hasClass('navbar-fixed-top')){
		$('.top-links').removeClass('navbar-fixed-top');
	}
	
	if($(document).scrollTop()>=mainCuttoff){
		$('.main-nav').addClass('navbar-fixed-top fixed-top-margin');
	}else if($('.main-nav').hasClass('navbar-fixed-top')){
		$('.main-nav').removeClass('navbar-fixed-top fixed-top-margin');
	}
	
}
function getDocHeight() {
    var D = document;
    return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
    );
}
function more(target){
	var next_page = Number($('form[name="'+target+'-nav"] input[name="page"]').val()) + 1;
	var all_pages = Number($('form[name="'+target+'-nav"] input[name="num_pages"]').val());
	
	$('form[name="'+target+'-nav"] input[name="page"]').val(next_page);
	$('.more-results[rel="'+target+'"]').addClass('loading');
	$.ajax({
		data:$('form[name="'+target+'-nav"]').serialize(),
		dataType:'html',
		success:function(data){
			$newItems = $.parseHTML( data );
			$.each( $newItems, function( i, el ) {
				$(el).data('duration', i ).appendTo('#'+target+'-list');			
			});		
			
			if(next_page==all_pages-1){
				$('.more-results[rel="'+target+'"]').hide();
			}else{
				$('.more-results[rel="'+target+'"]').removeClass('loading');		
			}
		}
	});
	
}
function filter(target){
	$.ajax({data:$('form[name="'+target+'-nav"]').serialize(),dataType:'html',success:function(data){
		 $('#'+target+'-list').html( data );	
	}});
}
function viewport() {
    return {
        height: $(window).innerHeight(),
        width: $(window).innerWidth(),
        breakPoint: function() {
            var w = this.width;
            if (w <= 1200) {
                if (w <= 992) {
                    if (w <= 768) {
                        return 'xsmall';
                    } else {
                        return 'small';
                    }
                } else {
                    return 'medium';
                }
            } else {
                return 'large';
            }
        }
    }
}
function registerGAEvent(category,action,title,value){
    if(typeof(gtag)!=='undefined'){
        gtag( 'event', action , {
		  	   'event_category': category,
		  	   'event_label': title,
		       'value': value
		});

         
    }
}


var ajax_contents = [];
var init_load_more = true;

function ajaxContent(c){


    $modal = $('#modal');
    var contents = c || '.ajax-content';
    $(contents).each(function () {
        ajax_contents.push(
            {
                'content':$(this).data('ajaxContent'),
                'target': $(this)
            }
        );
    });

    loadAjaxContent();
}
function more_results(target){	
	
		var next_page = Number($('form[name="'+target+'-nav"] input[name="page"]').val()) + 1;
   
		var all_pages = Number($('form[name="'+target+'-nav"] input[name="num_pages"]').val()) - 1 ;

		$('form[name="'+target+'-nav"] input[name="page"]').val(next_page);
		
		if(all_pages >= next_page ){
			init_load_more = true;
			$('.loading-more').show();

		}else{
			init_load_more = false;
			$('.loading-more').hide();
		}

		if(init_load_more){
			$.ajax({
				data:$('form[name="'+target+'-nav"]').serialize(),
				dataType:'html',
				success:function(data){
					if(data.length>0){
						$newItems = $.parseHTML( data );
						$('.loading-more').hide();
						$.each( $newItems, function( i, el ) {
							$(el).data('duration', i ).appendTo('#'+target+'-list');			
						});		

					}
					
				}
			});
	}
	
}
function updateNumPages(target){
	$.ajax({
		data:$('form[name="'+target+'-nav"]').serialize() + "&numpages=true",
		dataType:'html',
		success:function(data){
			 $('form[name="'+target+'-nav"] input[name="num_pages"]').val(data);			
		}
	});
}


function loadAjaxContent(){

    if(ajax_contents.length > 0){
        var target = ajax_contents[0].target,content =  ajax_contents[0].content;
        if(target.hasClass('ajax-load-initiated')) {
            ajax_contents.splice(0, 1);
            if(ajax_contents.length > 0){
                loadAjaxContent();
            }
            return false;
        }

        target.addClass('ajax-load-initiated');

        target.load(content,function(){
            var uniq = (Math.random() + '').replace('0.', '');
            target.removeClass('ajax-load-initiated');

            target.addClass('ajax-loaded-'+uniq);
            callbacks('.ajax-loaded-'+uniq);
            ajax_contents.splice(0, 1);
            if(ajax_contents.length > 0){
                loadAjaxContent();
            }
        });
    }else{
        $('.ajax-load-initiated').removeClass('ajax-load-initiated');
    }
}

function formatItemSelect (item) {
	
  if (!item.id) {
    return item.text;
  }
   var $item=item.text;
   if(item.element.className!=='' ||  typeof(item.element.className)!==null ){
  	$item = $(
		'<span class="'+item.element.className+'">' + item.text + '</span>'
  	);
  }
  return $item;
};


function restaurantsTopFilters(){
	
	var target = 'restaurants';

    $('.top-list-filters-wrapper select').select2({
    	templateResult: formatItemSelect
    });


    $('.toggle-sort-way' ).click(function() {
		 $(this).hide();
		 if($(this).hasClass('sort-way-asc')){
		 	$('.sort-way-desc').show();
		 	$('form[name="'+target+'-nav"] input[name="sort_way"]').val('DESC');
		 }else{
		 	$('.sort-way-asc').show();
		 	$('form[name="'+target+'-nav"] input[name="sort_way"]').val('ASC');
		 }

		 $.ajax({
			data:$('form[name="'+target+'-nav"]').serialize(),
			dataType:'html',
			success:function(data){
				updateNumPages(target);
				if(data.length>0){
					$newItems = $.parseHTML( data );
					$('#'+target+'-list').html($newItems);			
				}
				
			}
		});
	 	return false;
		
	});

   		$('.top-list-filters-wrapper .apply-filters' ).click(function() {
   			$('.sidebar-filter .filter-group').each(function() {
			var filter_val = $(this).val();
			var key = $(this).attr('id');
		 	$('form[name="'+target+'-nav"] input[name="'+key+'"]').val(filter_val);
			$('form[name="'+target+'-nav"] input[name="page"]').val(0);
		});
		$.ajax({
			data:$('form[name="'+target+'-nav"]').serialize(),
			dataType:'html',
			success:function(data){
				updateNumPages(target);
				if(data.length>0){
					$newItems = $.parseHTML( data );
					$('#'+target+'-list').html($newItems);			
				}
				
			}
		});
     	 $('body').removeClass('open-filter');
     	 return false;


   });


   	$('.dropdownlist #sort_term' ).change(function() {
   		var filter_val = $(this).val();
   		var key = $(this).attr('id');
   		$('form[name="'+target+'-nav"] input[name="'+key+'"]').val(filter_val);
		$('form[name="'+target+'-nav"] input[name="page"]').val(0);
   		$.ajax({
			data:$('form[name="'+target+'-nav"]').serialize(),
			dataType:'html',
			success:function(data){
				updateNumPages(target);
				if(data.length>0){
					$newItems = $.parseHTML( data );
					$('#'+target+'-list').html($newItems);			
				}
				
			}
		});

   	});

	
	$('.top-list-filters-wrapper .reset-filters' ).click(function() {
			$('.sidebar-filter .filter-group').val('');
			$('.sidebar-filter .filter-group').change();
			$('.sidebar-filter .filter-group').each(function() {
				var key = $(this).attr('id');
		 		$('form[name="'+target+'-nav"] input[name="'+key+'"]').val('');
				$('form[name="'+target+'-nav"] input[name="page"]').val(0);
			});
			$.ajax({
				data:$('form[name="'+target+'-nav"]').serialize(),
				dataType:'html',
				success:function(data){
					updateNumPages(target);
					if(data.length>0){
						$newItems = $.parseHTML( data );
						$('#'+target+'-list').html($newItems);
						
					}
					
					
				}
			});
 	 		$('body').removeClass('open-filter');
 	 		return false;
	});
	
}


function callbacks(c) {
    var container = c || '';
    ajaxContent(container + ' .ajax-content');

    $(container + ' .callbacks').each(function () {
        if(!$(this).hasClass('callbacks-executed')){
            if(container !=='' || !$(this).hasClass('callbacks-executed')){
                var c = $(this).data();
                for (var i in c) {
                    if (i.indexOf('fn') === 0 && c[i] !== '') {
                        var fn = c[i];
                        var params = c[ 'params' + i ] || null;

                        try {
                            if (c[ 'after' + i ] && typeof(window[c[ 'after' + i ]]) === 'function') {

                                var callbackAfter = c[ 'after' + i ];
                                var callbackAfterParams = c[ 'after' + i + 'Params' ] || null;

                                window[ fn ](params, function(){
                                    window[callbackAfter](callbackAfterParams);
                                });
                            } else {
                                window[ fn ](params);
                            }
							$(this).addClass('callbacks-executed');
                        } catch (Error) {
                            console.log(Error + ' '+fn);
                        }
                    }
                }
            }
        }
    });

}

function restaurantsInfiniteScroll(){
	var target = 'restaurants';
	$(window).scroll(function () {
		if ($(document).height() - $(this).height() == $(this).scrollTop()) {
			more_results(target);
		}
	}); 
}


function initHero(){
	$('.bxslider').bxSlider({
		  mode: 'horizontal', //horizontal', 'vertical', 'fade'
		  speed: 1000,
		  pause: 5000,
		  controls: ($(".bxslider>li").length > 1) ? true: false,
		  auto: ($(".bxslider>li").length > 1) ? true: false,
		  debug:false,              
		  video: true,              
		  useCSS: false              
	});
}

function initAccountHistory(){
	$('#account-history').dataTable({
		'iDisplayLength':10,
		"sPaginationType": "full_numbers",
		"bLengthChange": false,
		"bFilter": false,
		"bSort": false
	 });
	
}



function footerFeatured(){
	$('#footer_featured_items').bxSlider({ auto: true, 
			autoStart: true, 
			pause:4000, 
			speed:200, 
			displaySlideQty: 3, 
			moveSlideGty: 1 
	});
}

 function showClock() {
    var Digital = new Date();
    var hours = Digital.getHours();
    var minutes = Digital.getMinutes();
    var seconds = Digital.getSeconds();
    if (hours == 0)
        hours = 12;
    if (minutes <= 9)
        minutes = "0" + minutes;
    if (seconds <= 9)
        seconds = "0" + seconds;

    $('#fnlclock').html(hours + ":" + minutes + ":" + seconds);
    setTimeout("showClock()", 1000);
}


 function sidebarFilters() {
    $('.filter-toggle').click(function(){
		$('body').addClass('open-filter');
		 return false;
	});
     $('.filter-close').click(function(){
     	$('body').removeClass('open-filter');
     	 return false;
     });
    
	
}


 function initSearchForm() {
 	
    $('#top_nav_search_form').validate({
        rules: {
            'search-param': 'required'
        },
        messages: {
            'search-param': ''
        },
        submitHandler: function () {
        	$('.morphsearch-content div.dummy-column').hide();
            $('.morphsearch-content .search-results').html('<div class="bx-wrapper"><div class="bx-loading"></div></div>');
            $.ajax({data: $('#top_nav_search_form').serialize(), dataType: 'html', success: function (data) {

                registerGAEvent('Search',$('input[name="search-param"]').val(),window.location,'');

                $('.morphsearch-content .search-results').html(data);
                $('.morphsearch-content .search-results ul').addClass('loaded');
                $('.morphsearch-content .search-results .grid-item').addClass('shown');

                adaptive_images('.morphsearch-content .search-results');
            }});
        }
    });

    var morphSearch = $('#morphsearch'),
            input = $('.search-trigger'),
            ctrlClose = $('span.morphsearch-close'),
            isOpen = isAnimating = false,
        	
        	// show/hide search area
            
            toggleSearch = function (evt) {
                // return if open and the input gets focused
                var offsets = morphsearch.getBoundingClientRect();
                if (isOpen) {
					morphSearch.removeClass('open', function(){
						$('.morphsearch-content .search-results').empty();
						$('.morphsearch-content div.dummy-column').show();
						$('.morphsearch-input').val('');						
					});
					
                    //classie.remove( morphSearch, 'open' );

                    // trick to hide input text once the search overlay closes
                    // todo: hardcoded times, should be done after transition ends
                    if (input.value !== '') {
                        setTimeout(function () {
                            morphSearch.addClass('hideInput');
                            setTimeout(function () {
                                morphSearch.removeClass('hideInput');
                                input.value = '';
                            }, 300);
                        }, 500);
                    }
                    input.blur();
                }
                else {
                    morphSearch.addClass('open');
                    $('.morphsearch-input').focus();
                }
                isOpen = !isOpen;
                return false;
            };

        // events
        input.on('click', toggleSearch);		
		ctrlClose.on('click', toggleSearch);
        // esc key closes search overlay
        // keyboard navigation events
        $(document).on('keydown', function (ev) {
            var keyCode = ev.keyCode || ev.which;
            if (keyCode === 27 && isOpen) {
                toggleSearch(ev);
            }
        });
}


function initAltSearchForm(){
	
	$('#top_nav_search_form').validate({
		rules: {
			'search-param':'required'
		},
		messages:{
			'search-param':''
		},
		submitHandler: function() {
			$('.close-search').hide();
			$('.search-results').show();
			$('#top_nav_search_form').next().html('<div class="bx-wrapper"><div class="bx-loading"></div></div>');
			$.ajax({data:$('#top_nav_search_form').serialize(),dataType:'html',success:function(data){
				$('#top_nav_search_form').next().html(data);
				$('.close-search').show();
			}});
		}
	});
	
	$("#submit_search").click(function(){
		$('#top_nav_search_form').submit();
		return false;
	});
}